<template>
  <div class="confirm-address" ref="pdfAddress">
    <el-form
      :rules="rules"
      ref="formRental"
      class="form-rental"
      size="medium"
      :model="formRental"
    >
      <div class="form-box">
        <div class="title">
          Business Contacts Information
          <span style="float: right" class="flex-center">
            <el-checkbox v-model="formRental.saveDetails">Remember as default</el-checkbox>
          </span>
        </div>
        <div class="flex-center">
          <el-form-item prop="businessContactFirstName" label="First Name">
            <el-input
              @change="sameChecked" @input="sameChecked" v-model="formRental.businessContactFirstName"
            ></el-input>
          </el-form-item>
          <el-form-item prop="businessContactLastName" label="Last Name">
            <el-input
              @change="sameChecked" @input="sameChecked" v-model="formRental.businessContactLastName"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-center">
          <el-form-item prop="businessContactCompany" label="Company Name">
            <el-input @change="sameChecked" @input="sameChecked" v-model="formRental.businessContactCompany"></el-input>
          </el-form-item>
          <el-form-item prop="businessContactEmail" label="Email Address">
            <el-input @change="sameChecked" @input="sameChecked" v-model="formRental.businessContactEmail"></el-input>
          </el-form-item>
        </div>
        <div class="flex-center">
          <el-form-item prop="businessContactPhone" label="Mobile Phone Number">
            <el-input
              @change="sameChecked" @input="sameChecked" type="number" v-model="formRental.businessContactPhone"
            ></el-input>
          </el-form-item>
          <el-form-item label="Other Communication Methods">
            <el-select
              style="width: 40%;"
              popper-class="rentalSelect"
              clearable
              @change="sameChecked"
              @input="sameChecked"
              v-model="formRental.businessContactCommunicationType"
              placeholder="Select"
            >
              <el-option
                v-for="(item, index) in communicationTypeList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              class="otherInput" prop="businessOtherCommunicationMethods"
              @change="sameChecked"
              @input="sameChecked"
              v-model="formRental.businessOtherCommunicationMethods"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-center">
          <el-form-item prop="businessContactCountry" label="Country/Region">
            <el-select
              clearable
              filterable
              popper-class="rentalSelect"
              @change="sameCheckedBusRegion('busRegion')"
              v-model="formRental.businessContactCountry"
              placeholder="Country/Region"
            >
              <el-option
                v-for="(item, index) in locationList"
                :key="index"
                :label="item.country"
                :value="item.country"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="businessContactState" label="State/Province">
            <el-select
              clearable
              filterable
              popper-class="rentalSelect"
              v-model="formRental.businessContactState"
              placeholder="State/Province"
            >
              <el-option
                v-for="(item, index) in businessStateList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!--        <div class="flex-center">-->
        <!--          <el-checkbox v-model="formRental.saveDetails">Save my Data for the next time</el-checkbox>-->
        <!--        </div>-->
      </div>
      <div class="line"></div>
      <div class="form-box">
        <div style="display: flex; justify-content: space-between;">
          <div class="title">Shipping Contacts information</div>
        </div>
        <div style="width: 100%;overflow: hidden" class="contactInfo">
          <p class="contactTitle">
            <span>*</span>
            Contacts Type
          </p>
          <el-radio-group v-model="formRental.shippingInfo" @input="shippingContactTypeChanged">
            <el-radio label="addShippingInfoNow" class="radioStyle">Add shipping
              info now
            </el-radio>
            <el-radio label="sameAsBusinessContact" class="radioStyle">Same as business
              Contact
            </el-radio>
            <el-radio label="addShippingInfoLater" class="radioStyle">Add shipping
              info later
            </el-radio>
          </el-radio-group>
          <p class="laterType" v-if="formRental.shippingInfo === 'addShippingInfoLater'">Note:TVU will not be able to
            further process
            this
            rental request until further details
            are provided.
          </p>
        </div>
        <div class="flex-center" :class="{contactLater : formRental.shippingInfo === 'addShippingInfoLater'}">
          <el-form-item prop="shippingContactFirstName" label="First Name">
            <el-input
              :disabled="!canInput"
              v-model="formRental.shippingContactFirstName"
              @input="checkWhetherChangeType"
            ></el-input>
          </el-form-item>
          <el-form-item prop="shippingContactLastName" label="Last Name">
            <el-input
              :disabled="!canInput"
              v-model="formRental.shippingContactLastName"
              @input="checkWhetherChangeType"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-center" :class="{contactLater : formRental.shippingInfo === 'addShippingInfoLater'}">
          <el-form-item prop="shippingContactCompany" label="Company Name">
            <el-input :disabled="!canInput" v-model="formRental.shippingContactCompany"></el-input>
          </el-form-item>
          <el-form-item prop="shippingContactEmail" label="Email Address">
            <el-input
              :disabled="!canInput"
              v-model="formRental.shippingContactEmail"
              @input="checkWhetherChangeType"
            ></el-input>
          </el-form-item>
        </div>
        <div class="flex-center" :class="{contactLater : formRental.shippingInfo === 'addShippingInfoLater'}">
          <el-form-item prop="shippingContactPhone" label="Mobile Phone Number">
            <el-input
              :disabled="!canInput"
              type="number"
              v-model="formRental.shippingContactPhone"
              @input="checkWhetherChangeType"
            ></el-input>
          </el-form-item>
          <el-form-item label="Other Communication Methods">
            <el-select
              style="width: 40%;"
              clearable
              v-model="formRental.shippingContactCommunicationType"
              placeholder="Select"
              popper-class="rentalSelect"
              :disabled="!canInput"
            >
              <el-option
                v-for="(item, index) in communicationTypeList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              class="otherInput" prop="shippingOtherCommunicationMethods" :disabled="!canInput"
              v-model="formRental.shippingOtherCommunicationMethods"
            ></el-input>
          </el-form-item>
        </div>
        <div class="title-shipping" :class="{contactLater : formRental.shippingInfo === 'addShippingInfoLater'}">
          <span class="red">*</span>
          Shipping Address
        </div>
        <el-form-item prop="shippingAddress1">
          <el-input v-model="formRental.shippingAddress1" placeholder="Shipping Address Line 1"></el-input>
        </el-form-item>
        <div class="flex-center">
          <el-form-item prop="shippingAddress2">
            <el-input v-model="formRental.shippingAddress2" placeholder="Shipping Address Line 2(Optional)"></el-input>
          </el-form-item>
          <el-form-item prop="buildingName">
            <el-input v-model="formRental.buildingName" placeholder="Building Name(Optional)"></el-input>
          </el-form-item>
        </div>
        <div class="flex-center">
          <el-form-item prop="shippingCountry" label="Country/Region">
            <el-select
              style="width: 100%;"
              clearable
              filterable
              popper-class="rentalSelect"
              v-model="formRental.shippingCountry"
              @change="shippingCountryChange"
              placeholder="Country/Region"
            >
              <el-option
                v-for="(item, index) in locationList"
                :key="index"
                :label="item.country"
                :value="item.country"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="shippingState" label="State/Province(Optional)">
            <el-select
              clearable
              filterable
              popper-class="rentalSelect"
              v-model="formRental.shippingState"
              placeholder="State/Province(Optional)"
            >
              <el-option
                v-for="(item, index) in deliveryStateList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex-center">
          <el-form-item prop="shippingCity" label="City">
            <el-input v-model="formRental.shippingCity" placeholder="City"></el-input>
          </el-form-item>
          <el-form-item
            prop="shippingZipCode" label="Postal Code"
            :class="{contactLater : formRental.shippingInfo === 'addShippingInfoLater'}"
          >
            <el-input v-model="formRental.shippingZipCode" placeholder="Postal Code"></el-input>
          </el-form-item>
        </div>
        <div class="flex-center">
          <!--          <el-checkbox v-model="formRental.sendRentalRequestConfirmationMailToShippingContact"-->
          <!--            :disabled="!formRental.shippingContactEmail"-->
          <!--          >-->
          <el-checkbox
            v-model="formRental.sendRentalRequestConfirmationMailToShippingContact"
          >
            Send confirmation email to shipping contact
          </el-checkbox>
        </div>
      </div>
    </el-form>
    <div class="next-box">
      <!--    <div class="number-box">-->
      <!--      <span>Internal Number:</span>-->
      <!--      <el-input size="small" v-model="formRental.internalNumber" placeholder="Optional"></el-input>-->
      <!--    </div>-->
      <el-button size="small" type="primary" @click="onNext">Next</el-button>
    </div>
  </div>
</template>

<script>
import { getUrlParam } from '@/assets/js/utils'

export default {
  name: 'ConfirmAddress',
  props: {
    locationList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    const checkValue = (rule, value, callback) => {
      if (this.formRental.shippingInfo === 'addShippingInfoLater') {
        callback()
        return
      }
      if (!value) {
        return callback(new Error('Please complete this required field.'))
      } else {
        if (rule.field === 'shippingContactEmail') {
          if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)) {
            callback(new Error('Invalid Email Formats!'))
          }
        }
        callback()
      }
    }
    return {
      formRental: {
        // Business Contacts Information
        businessContactFirstName: '',
        businessContactLastName: '',
        businessContactCompany: '',
        businessContactEmail: '',
        businessContactPhone: '',
        businessContactCommunicationType: '',
        businessOtherCommunicationMethods: '',
        businessContactCountry: '',
        businessContactState: '',
        // Shipping Contacts information
        shippingContactFirstName: '',
        shippingContactLastName: '',
        shippingContactCompany: '',
        shippingContactEmail: '',
        shippingContactPhone: '',
        shippingOtherCommunicationMethods: '',
        shippingContactCommunicationType: '',
        // Shipping Address
        shippingAddress1: '',
        shippingAddress2: '',
        buildingName: '',
        shippingCountry: '',
        shippingState: '',
        shippingCity: '',
        shippingZipCode: '',
        // internalNumber: ''
        saveDetails: true,
        sendRentalRequestConfirmationMailToShippingContact: false,
        shippingInfo: 'addShippingInfoNow'
      },
      checked: false,
      canInput: true,
      businessStateList: [],
      deliveryStateList: [],
      communicationTypeList: ['WhatsApp', 'WeChat', 'Slack'],

      rules: {
        businessContactFirstName: [
          { required: true, message: 'Please complete this required field.', trigger: 'blur' }
        ],
        businessContactLastName: [
          { required: true, message: 'Please complete this required field.', trigger: 'blur' }
        ],
        businessContactEmail: [
          { required: true, message: 'Please complete this required field.', trigger: 'blur' },
          { pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: 'Invalid Email Formats!', trigger: 'blur' }
        ],
        businessContactPhone: [
          { required: true, message: 'Please complete this required field.', trigger: 'change' }
        ],
        businessContactCountry: [
          { required: true, message: 'Please complete this required field.', trigger: 'change' }
        ],
        shippingContactFirstName: [
          {
            required: true,
            message: 'Please complete this required field.',
            trigger: 'change',
            validator: checkValue
          }
        ],
        shippingContactLastName: [
          {
            required: true,
            message: 'Please complete this required field.',
            trigger: 'change',
            validator: checkValue
          }
        ],
        shippingContactEmail: [
          {
            required: true,
            trigger: 'change',
            validator: checkValue
          }
          // { pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: 'Invalid Email Formats!', trigger: 'change' }
        ],
        shippingContactPhone: [
          {
            required: true,
            message: 'Please complete this required field.',
            trigger: 'change',
            validator: checkValue
          }
        ],
        shippingAddress1: [
          { required: true, message: 'Please complete this required field.', trigger: 'change', validator: checkValue }
        ],
        // shippingAddress2: [
        //   { required: true, message: 'Please complete this required field.', trigger: 'change' }
        // ],
        // buildingName: [
        //   { required: true, message: 'Please complete this required field.', trigger: 'change' }
        // ],
        shippingCountry: [
          { required: true, message: 'Please complete this required field.', trigger: 'change' }
        ],
        // shippingState: [
        //   { required: true, message: 'Please complete this required field.', trigger: 'change' }
        // ],
        shippingCity: [
          { required: true, message: 'Please complete this required field.', trigger: 'blur' }
        ],
        shippingZipCode: [
          { required: true, message: 'Please complete this required field.', trigger: 'blur', validator: checkValue }
        ]
      }
    }
  },
  mounted () {
    let confirmAddress
    let confirmAddressChecked = false
    if (this.$route.path === '/print') {
      confirmAddress = JSON.parse(getUrlParam('confirmAddress') || '{}')
      // console.log(getUrlParam('confirmAddressChecked'))
      confirmAddressChecked = getUrlParam('confirmAddressChecked')
    } else {
      if (localStorage.getItem('confirmAddress')) {
        confirmAddress = JSON.parse(localStorage.getItem('confirmAddress'))
        confirmAddressChecked = localStorage.getItem('confirmAddressChecked')
      }
      // else {
      //   this.getSavedUserInfo()
      // }
    }
    if (confirmAddress) {
      this.formRental = confirmAddress
      if (this.formRental.businessContactCountry) {
        const finItem = this.locationList.find(item => item.country === this.formRental.businessContactCountry)
        this.businessStateList = finItem ? finItem.stateList : []
      }
      if (this.formRental.shippingCountry) {
        const finItem = this.locationList.find(item => item.country === this.formRental.shippingCountry)
        this.deliveryStateList = finItem ? finItem.stateList : []
      }
      this.checked = confirmAddressChecked === 'true'
      if (this.checked) this.canInput = false
    } else {
      this.getSavedUserInfo()
    }
  },
  methods: {
    onNext () {
      this.$refs.formRental.validate(valid => {
        if (valid) {
          localStorage.setItem('confirmAddress', JSON.stringify(this.formRental))
          localStorage.setItem('confirmAddressChecked', this.checked)
          this.$emit('addressNext', JSON.stringify(this.formRental), this.checked)
        } else {
          if (this.formRental.shippingInfo !== 'addShippingInfoNow') {
            if (!this.formRental.shippingCountry || !this.formRental.shippingCity) {
              this.$message.warning('The minimum information required at this stage is Country/Region and City!')
            }
            return false
          }
        }
      })
    },
    shippingCountryChange () {
      const finItem = this.locationList.find(item => item.country === this.formRental.shippingCountry)
      this.deliveryStateList = finItem ? finItem.stateList : []
      this.formRental.shippingState = ''
    },
    sameCheckedBusRegion (type) {
      if (type === 'busRegion') {
        const finItem = this.locationList.find(item => item.country === this.formRental.businessContactCountry)
        this.businessStateList = finItem ? finItem.stateList : []
        this.formRental.businessContactState = ''
      }
    },
    sameChecked () {
      /*
       * 修改说明:  https://tvunetworks.slack.com/archives/C092V74QCBD/p1751996719225059
       *  */
      if (this.formRental.shippingInfo === 'sameAsBusinessContact') {
        const {
          businessContactFirstName,
          businessContactLastName,
          businessContactCompany,
          businessContactEmail,
          businessContactPhone,
          businessOtherCommunicationMethods,
          businessContactCommunicationType
        } = this.formRental
        this.formRental.shippingContactFirstName = businessContactFirstName
        this.formRental.shippingContactLastName = businessContactLastName
        this.formRental.shippingContactCompany = businessContactCompany
        this.formRental.shippingContactEmail = businessContactEmail
        this.formRental.shippingContactPhone = businessContactPhone
        this.formRental.shippingOtherCommunicationMethods = businessOtherCommunicationMethods
        this.formRental.shippingContactCommunicationType = businessContactCommunicationType
        this.canInput = false
      } else {
        this.canInput = true
      }
    },
    getSavedUserInfo () {
      const prames = {
        rentalType: 'RedBull'
      }
      this.$axios.post('/rental-forecasting/hubSpot/rental/getRequestData', prames).then(res => {
        if (res.data && res.data.errorCode === '0x0' &&
          res.data.result &&
          res.data.result.list &&
          res.data.result.list.length > 0
        ) {
          let info = res.data.result.list[0].requestData
          if (info) {
            info = JSON.parse(info)
          }
          const {
            businessContactFirstName,
            businessContactLastName,
            businessContactCompany,
            businessContactEmail,
            businessContactPhone,
            businessContactCommunicationType,
            businessOtherCommunicationMethods,
            businessContactCountry,
            businessContactState,
            saveDetails,
            shippingInfo
          } = info
          const shippingInfoLocal = window.localStorage.getItem('shippingInfo')
          if (shippingInfoLocal) {
            this.formRental.shippingInfo = shippingInfoLocal
          } else {
            this.formRental.shippingInfo = shippingInfo || 'addShippingInfoNow'
          }
          if (saveDetails) {
            this.formRental.businessContactFirstName = businessContactFirstName
            this.formRental.businessContactLastName = businessContactLastName
            this.formRental.businessContactCompany = businessContactCompany
            this.formRental.businessContactEmail = businessContactEmail
            this.formRental.businessContactPhone = businessContactPhone
            this.formRental.businessContactCommunicationType = businessContactCommunicationType
            this.formRental.businessOtherCommunicationMethods = businessOtherCommunicationMethods
            this.formRental.businessContactCountry = businessContactCountry
            if (businessContactCountry) {
              // https://tvunetworks.atlassian.net/browse/RF-5
              this.sameCheckedBusRegion('busRegion')
            }
            this.formRental.businessContactState = businessContactState
            if (this.formRental.businessContactCountry) {
              const finItem = this.locationList.find(item => item.country === this.formRental.businessContactCountry)
              this.businessStateList = finItem ? finItem.stateList : []
            }
          }
          if (shippingInfo && shippingInfo === 'sameAsBusinessContact') {
            this.sameChecked()
          }
          this.formRental.saveDetails = !!saveDetails
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    shippingContactTypeChanged: function () {
      if (this.formRental.shippingInfo === 'sameAsBusinessContact') {
        this.sameChecked()
      } else {
        this.canInput = true
        if (this.formRental.shippingInfo === 'addShippingInfoLater') {
          // this.checkWhetherChangeType()
          this.formRental.shippingContactFirstName = ''
          this.formRental.shippingContactLastName = ''
          this.formRental.shippingContactEmail = ''
          this.formRental.shippingContactPhone = ''
          // RF-44
          this.formRental.shippingAddress1 = ''
          // this.formRental.shippingAddress2 = ''
          // RF-29
          this.formRental.sendRentalRequestConfirmationMailToShippingContact = false
        }
      }
      window.localStorage.setItem('shippingInfo', this.formRental.shippingInfo)
    },
    checkWhetherChangeType () {
      // if (this.formRental.shippingContactFirstName &&
      //   this.formRental.shippingContactLastName &&
      //   this.formRental.shippingContactEmail &&
      //   this.formRental.shippingContactPhone
      // ) {
      //   this.formRental.shippingInfo = 'addShippingInfoNow'
      // }
    }
  }
}
</script>

<style scoped lang="less">
.contactLater {
  /deep/ .el-form-item__label {
    &::before {
      content: "" !important;
    }
  }
}

.title-shipping.contactLater {
  span.red {
    display: none;
  }
}

.form-rental {
  display: flex;
  margin-bottom: 16px;

  .form-box {
    width: 538px;
    border-radius: 4px;
    border: 2px solid #DBDBDB;
    background: #FAFAFA;
    padding: 24px 12px 8px 12px;

    .title {
      color: #69AD48;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 18px;
    }

    .contactInfo {
      color: #000000;

      .contactTitle {
        font-size: 14px;
        line-height: 36px;

        span {
          color: red;
        }
      }

      .radioStyle {
        font-weight: normal;
        font-size: 14px;
        float: left;
        height: 30px
      }

      .laterType {
        color: #F68512;
        margin-bottom: 10px;
      }
    }
  }

  .line {
    border-right: dashed 2px #DBDBDB;
    height: 723px;
    margin: 0 24px;
  }

  .title-shipping {
    font-size: 14px;
    color: #000000;
    margin: 6px 0;

    .red {
      color: #EC5050;
    }
  }

  /deep/ .el-input__inner {
    border-color: #DBDBDB;
    background: #FAFAFA !important;
  }

  .flex-center {
    display: flex;

    /deep/ .el-input__inner {
      width: 247px;
      border-color: #DBDBDB;
      background: #FAFAFA !important;
    }

    /deep/ .el-input__inner::placeholder {
      color: #DBDBDB;
    }

    :nth-child(2).el-form-item {
      margin-left: 16px;
    }

    /deep/ .el-checkbox__label {
      color: #000 !important;
    }
  }

  .otherInput {
    width: 55%;

    /deep/ .el-input__inner {
      width: 150px;
    }
  }

  .marginL-16 {
    margin-left: 16px;
  }

  .el-form-item {
    margin-bottom: 16px;
  }

  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #DBDBDB;
  }
}

.next-box {
  display: flex;
  justify-content: flex-end;
}

.number-box {
  display: flex;
  align-items: center;
  margin-right: 24px;
  color: #000000;
  font-size: 14px;

  span {
    margin-right: 6px;
  }

  /deep/ .el-input {
    width: 160px;
  }
}
</style>
